var map = {
	"./README.md": 7239,
	"./en/help/about_dezrann.md": 6680,
	"./en/help/dev_doc.md": 6218,
	"./en/help/first_steps.md": 8759,
	"./en/help/label_templates.md": 1938,
	"./en/help/labels_and_analyzes.md": 4,
	"./en/help/new_piece.md": 1291,
	"./en/help/views.md": 3763,
	"./fr/help/about_dezrann.md": 4532,
	"./fr/help/first_steps.md": 6605,
	"./fr/help/label_templates.md": 1691,
	"./fr/help/labels_and_analyzes.md": 9123,
	"./fr/help/new_piece.md": 4007,
	"./fr/help/views.md": 4688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1028;